import { Routes, Route, Navigate } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { SignIn } from "./pages/SignIn";
import { CheckEmail } from "./pages/CheckEmail";
import { Dashboard } from "./pages/Dashboard";
import { CreateCircle } from "./pages/CreateCircle";
import { Settings } from "./pages/admin/Settings";
import { InviteAccept } from "./pages/InviteAccept";
import { VisitsList } from "./pages/VisitsList";
import { VisitNew } from "./pages/VisitNew";
import { VisitDetail } from "./pages/VisitDetail";
import { VisitEdit } from "./pages/VisitEdit";
import { CalendarView } from "./pages/CalendarView";
import { Notifications } from "./pages/Notifications";
import { Help } from "./pages/Help";
import { RequestAccess } from "./pages/RequestAccess";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { Support } from "./pages/Support";
import { SupportThanks } from "./pages/SupportThanks";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signin/sent" element={<CheckEmail />} />
      <Route path="/invites/:token" element={<InviteAccept />} />
      <Route path="/app" element={<Dashboard />} />
      <Route path="/app/create-circle" element={<CreateCircle />} />
      <Route path="/app/settings" element={<Settings />} />
      <Route path="/app/visits" element={<VisitsList />} />
      <Route path="/app/visits/new" element={<VisitNew />} />
      <Route path="/app/visits/:id" element={<VisitDetail />} />
      <Route path="/app/visits/:id/edit" element={<VisitEdit />} />
      <Route path="/app/calendar" element={<CalendarView />} />
      <Route path="/app/notifications" element={<Notifications />} />
      <Route path="/app/help" element={<Help />} />
      <Route path="/request-access" element={<RequestAccess />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/support" element={<Support />} />
      <Route path="/support/thanks" element={<SupportThanks />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
